import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

const validationMessage = () => (
  <FormattedMessage
    defaultMessage='Please select a value'
    id='sputnik.goodFitSurveyValidationSchema__qpTT7a'
  />
)

export const goodFitSurveyValidationSchema = yup.object().shape({
  annualRevenue: yup.string().required(validationMessage),
  currentCash: yup.string().required(validationMessage),
  creditRange: yup.string().required(validationMessage),
  __currentStep: yup.number().required(),
  __totalStepCount: yup.number().required(),
})

export type GoodFitSurveyValidationSchema = yup.InferType<typeof goodFitSurveyValidationSchema>
